(function () {
  angular.module('app.core.invites').factory('invitesStorage', service);

  /* @ngInject */
  function service($log, INVITATION_CACHE) {
    this.getCachedInviteCode = getCachedInviteCode;
    this.hasCachedInviteCode = hasCachedInviteCode;
    this.removeCachedInviteCode = removeCachedInviteCode;
    this.setCachedInviteCode = setCachedInviteCode;

    return {
      getCachedInviteCode,
      hasCachedInviteCode,
      removeCachedInviteCode,
      setCachedInviteCode,
    };

    ////////////

    function getCachedInviteCode() {
      try {
        return sessionStorage.getItem(INVITATION_CACHE.CODE);
      } catch (error) {
        $log.warn('sessionStorage.getItem() is not supported');
        return null;
      }
    }

    function hasCachedInviteCode() {
      return !!getCachedInviteCode();
    }

    function removeCachedInviteCode() {
      try {
        sessionStorage.removeItem(INVITATION_CACHE.CODE);
      } catch (error) {
        $log.warn('sessionStorage.removeItem() is not supported');
      }
    }

    function setCachedInviteCode(code) {
      try {
        sessionStorage.setItem(INVITATION_CACHE.CODE, code);
      } catch (error) {
        $log.warn('sessionStorage.setItem() is not supported');
      }
    }
  }
})();
